import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { Typography } from '@mui/material';
import SettingsView from './SettingsView';
import { config_path } from '../../router/config.path';
import { menuItems } from '../../menu.config';
import { checkActionPermission, filterShortcutByPermission, getData, isNeedToCheckPermission, logOut, saveDataIntoAsyncStore } from '../../utils/common';
import { formatDateToEpoch, sortByPosition } from '../../utils/util';
import crmservices from '../../wsclient';
import { dataUtil } from '../../wsclient/crmservices/dataUtil';
import { enumConfig, portal_config } from '../../portal.config';
import PaymentMethodsController from '../my-cards/PaymentMethodsController';
import PersonalInformationController from '../profile/PersonalInformationController';
import MarketingPreferencesController from '../marketing-preferences/MarketingPreferencesController';
import NotificationsController from '../notifications/NotificationsController';
import CommercePreferencesController from '../../custom_src/pages/commerce-preferences/CommercePreferencesController';
import SecurityController from '../security/SecurityController';
import { custom_page } from '../../custom.config';
import FormalitiesController from '../informations/FormalitiesController';
import ContactUs from '../informations/ContactUs';
import ServiceRequestController from '../service-request/ServiceRequestController';
import MobilePassCardController from '../mobile-pass-card/MobilePassCardController';
import { cache } from '../../utils/cache';
import moment from 'moment';
import { setUnreadNotification } from '../../redux/actions';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { store } from '../../redux/store';
import AddressController from '../profile/AddressController';
import FAQs from '../informations/FAQs';
import ConfirmComponent from '../../components/Confirm';
import { useTranslation } from 'react-i18next';
import AlertComponent from '../../components/Alert';
import LearnController from '../onboarding/LearnController';

const MyCardsPage = custom_page.my_card && custom_page.my_card.controller ? require('../../custom_src/pages/my-cards/MyCardsController').default : PaymentMethodsController
const PersonalInformationPage = custom_page.profile && custom_page.profile.controller ? require('../../custom_src/pages/profile/PersonalInformationController').default : PersonalInformationController
const MarketingPreferencesPage = custom_page.marketing_preferences && custom_page.marketing_preferences.controller ? require('../../custom_src/pages/marketing-preferences/MarketingPreferencesController').default : MarketingPreferencesController
const NotificationsPage = custom_page.notifications && custom_page.notifications.controller ? require('../../custom_src/pages/notifications/NotificationsController').default : NotificationsController
const CommercePreferencesPage = custom_page.commerce_preferences && custom_page.commerce_preferences.controller ? require('../../custom_src/pages/commerce-preferences/CommercePreferencesController').default : CommercePreferencesController
const SecurityPage = custom_page.security && custom_page.security.controller ? require('../../custom_src/pages/security/SecurityController').default : SecurityController


export default function SettingsController(props) {
    const appConfig = cache.getAppConfig();
    const location = useLocation();
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [joinedCommunities, setJoinedCommunities] = useState([]);
    const [target, setTarget] = useState({});
    const [profileImage, setProfileImage] = useState(null);
    const [showLoadingProfileImage, setShowLoadingProfileImage] = useState(false);
    const [profile, setProfile] = useState(null);
    const [unreadNotificationNumber, setUnreadNotificationNumber] = useState(0);
    const [communicationId, setCommunicationId] = useState(searchParams.get("communication_id"))
    const [notificationMessage, setNotificationMessage] = useState(null);
    const [confirm, setConfirm] = useState({});
    const [message, setMessage] = useState(null);
    const [showProcessing, setShowProcessing] = useState(false);
    const [allowAction, setAllowAction] = useState(false);
    const [isCommunityWorkspace, setIsCommunityWorkspace] = useState(false);
    const [communityRelation, setCommunityRelation] = useState(null);
    const [showMessageLogoutCommunity, setShowMessageLogoutCommunity] = useState(false);
    const unreadNotification = useSelector(state=>state.ConfigurationReducer.unreadNotification);
    let showSecurity=appConfig.authentication && appConfig.authentication.email_password ?true:false;
    let isMobilePassSupported=appConfig.features && appConfig.features.contact && appConfig.features.contact.mobile_pass && appConfig.features.contact.mobile_pass.is_supported;
    const { t } = useTranslation();
    const isGuest = cache.getIsGuest();
    
    useEffect(() => {
        if (unreadNotification) {  
            setNotificationMessage({
                ...unreadNotification,
                content: unreadNotification.title,
                id: unreadNotification.id,
            });
            toast.dismiss();
            store.dispatch(setUnreadNotification(null));
            
        }
        
    }, [unreadNotification])

    useEffect(() => {
        const loadAllData = async () => {
          setShowProcessing(true);
          try {
            await Promise.all([
              onLoadJoinedCommunities(),
              onLoadProfile(),
              onLoadUnreadNotification(),
              checkAllowPermission()
            ]);
          } catch (error) {
            console.error("Error loading initial data:", error);
          } finally {
            setShowProcessing(false);
          }
        };
      
        loadAllData();
      }, []);
      

    const onLoadJoinedCommunities = async () => {
        try {
            let joinedCommunities = [];
            let _joinedCommunities = [];
            const result = await crmservices.communitity.getListJoinedCommunities();
            if (result.code == 'OK' && result.data.content) {
                joinedCommunities = await dataUtil.getJoinedCommunities(result.data.content);
                if (joinedCommunities && joinedCommunities.length > 0) {
                    joinedCommunities.forEach(item => {
                        let isAccess = true;
                        let isAdmin = item.is_admin;
                        if (!isAdmin) {
                            if (item.permissions && item.permissions.length > 0) {
                                isAccess = true
                            } else {
                                isAccess = false
                            }
                        }
                        item.is_access = isAccess;
                        if(item.is_access) {
                            _joinedCommunities.push(item)
                        }
                    });
                    cache.setHasCommunities(true);
                }
            }
            setJoinedCommunities(_joinedCommunities);

        } catch (error) {
            console.log("onLoadJoinedCommunities error:", error);
        }
    }

    const onLoadProfile = async (file) => {
        setShowLoadingProfileImage(true);
        try {
            if (file && file.uri) {
                setProfileImage(file.uri);
            }
            else {
                if(!profile){
                    var result = await crmservices.contacts.getContact();
                    if (result.code === 'OK') {
                        let data = result.data;
                        setProfile(data);
                        cache.setContact(data);
                        if (data.avatar_url) {
                            setProfileImage(data.avatar_url);
                        }
                        else {
                            setProfileImage(null);
                        }
                    }
                }
                else{
                    setProfile(profile);
                    if(profile.avatar_url){
                        setProfileImage(profile.avatar_url);
                    }
                    else{
                        setProfileImage(null);
                    }
                }
            }
        } catch (error) {
            console.log("AAAA onLoadProfile exception: ", error)
        }
        setShowLoadingProfileImage(false);
    }

    const onLoadUnreadNotification = async () => {
        var total = 0;
        const fromDate = formatDateToEpoch(moment().add(-3, 'month').startOf('month').hour(0).minute(0).second(0).toDate());
        const endDate  = formatDateToEpoch(moment().hour(23).minute(59).second(59).toDate());
        const numberUnreadInfo=cache.getNumberOfUnreadNotifications();
        if(numberUnreadInfo&& fromDate===numberUnreadInfo.fromDate && endDate===numberUnreadInfo.endDate){
            total=numberUnreadInfo.number;
        }
        else
        {
        try {
            var result = await crmservices.communications.getCommunications({ viewed: false, created_on_gte: fromDate ,created_on_lte: endDate });
            if (result.code === 'OK') {
                total = result.data.paging && result.data.paging.total ? result.data.paging.total : 0;
                cache.setNumberOfUnreadNotifications(fromDate,endDate,total);
            } else {
                console.log("get unread notifications error:", result);
            }
        } catch (error) {
            console.log("get unread notifications exception:", error);
        }
        }
        setUnreadNotificationNumber(total);
    }

    const checkAllowPermission = async () => {
        let _isCommunityWorkspace = isNeedToCheckPermission();
        let _communityRelation = getData('community_relation');
        setIsCommunityWorkspace(_isCommunityWorkspace)
        setCommunityRelation(_communityRelation)
        let _isAllowAction = checkActionPermission(enumConfig.contactPermissions.CONTACT_MANAGEMENT);
        setAllowAction(_isAllowAction);
        setIsCommunityWorkspace(_isCommunityWorkspace);
        setCommunityRelation(_communityRelation);
    }

    const getSettingsProfileConfig = () => {
        let _menu = [];
        menuItems.forEach(section => {
            if((isGuest && section.showInGuestMode) || !isGuest){
                let items = section.items;
                items.forEach(item => {
                    if(item.id === 'switch_roles')
                    {
                        item.enable = joinedCommunities && joinedCommunities.length > 0 ? true : false;
                        _menu.push(item);
                    }
                    else {
                        _menu.push(item);
                    }
                })
            }
        });
        _menu = filterShortcutByPermission(_menu, portal_config.isInvisibleAction);
        
        const allowedIds = new Set(_menu.map(item => item.id));
        const filteredMenuItems = menuItems
        .map(section => ({
            ...section,
            items: section.items.filter(item => allowedIds.has(item.id))
        }))
        .filter(section => section.items.length > 0);

        return filteredMenuItems;
    }

    const settingsConfig = getSettingsProfileConfig();

    const getInformationConfig = (type) => {
        const appConfig = cache.getAppConfig();
        let content = null;
        const contents = appConfig.information && appConfig.information.content ? appConfig.information.content : [];
        const contentsByType = contents.filter(c => {
            return c.type == type;
        })
        if (contentsByType && contentsByType.length > 0) {
            content = contentsByType[0];
        }
        return content;
    }

    const onClickItemProcess = async (target) => {
        if (target === 'unregister') {
            setConfirm({
                show: true,
                message: t('unregister_confirm'),
                title: t('unregister'),
                actionTitle: t('yes'),
                // closeTitle: t('btn_cancel'),
                onAction: () => onUnregisterContact(),
                onClose: () => setConfirm({})
            });
        } else if (target === 'logout_community') {
            await onLogoutCommunity()
        } else if (target === 'faqs'){
            const faqsContent = getInformationConfig("FAQS");
            if(faqsContent && faqsContent.url) {
                window.open(faqsContent.url, '_blank')
            } else {
                setTarget({
                    [target]: true,
                })
            }
        }
        else {
            setTarget({
                [target]: true,
            })
        }
    }

    const onClickMenu = (item, event, from) => {
        if (item.route) {
            navigate(item.route, { state: { from: from } })
        } else {
            onClickItemProcess(item.id)
        }
    }

    const onLogout = async (event) => {
        await logOut(undefined, navigate)
    }

    const onLogoutCommunity = async () => {
        setShowProcessing(true);
        try {
            var initial_contact_id = getData('initial_contact_id');
            var community_id = getData('community_id');
            const result = await crmservices.communitity.switchRole(initial_contact_id);
            setShowProcessing(false);
            if (result.code === 'OK') {
                saveDataIntoAsyncStore('current_workspace', 'main_application');
                if (window.location.pathname === config_path.home) {
                    window.location.reload();
                } else navigate(config_path.home);
            } else {
                setShowMessageLogoutCommunity(true);
            }
        } catch (ex) {
            console.log("onLogoutCommunity ex:", ex);
            setShowMessageLogoutCommunity(true);
        }
    }

    const onUnregisterContact = async () => {
        setConfirm({});
        setShowProcessing(true);
        try {
            const result = await crmservices.contacts.unregisterContact();
            if (result.code === 'OK') {
                showMessage({ status: true, message: t('UNREGISTER_CONTACT_SUCCESSFULLY'), callBackFn: () => onLogout() });
            } else if (result.code === 'CANNOTUNREGISTERCONTACTEXCEPTION') {
                let parameters = result.data.parameters && result.data.parameters.length > 0 ? result.data.parameters[0] : null;
                if (parameters === 'Contact has active subscription service') {
                    showMessage({ status: true, message: t('UNREGISTER_CONTACT_EXCEPTION_ACTIVE_SUB') });
                } else if (parameters === 'Contact has rented devices') {
                    showMessage({ status: true, message: t('UNREGISTER_CONTACT_EXCEPTION_RENTED_DEVICE') });
                } else if (parameters === 'Contact has incomplete order') {
                    showMessage({ status: true, message: t('UNREGISTER_CONTACT_EXCEPTION_INCOMPLETE_ORDER') });
                } else if (parameters === 'Contact has unpaid account balance') {
                    showMessage({ status: true, message: t('UNREGISTER_CONTACT_EXCEPTION_UNPAID_ACCOUNT') });
                } else {
                    showMessage({ status: true, message: t('EXCEPTION_PROCESS') });
                }
            } else {
                showMessage({ status: true, message: t('EXCEPTION_PROCESS') });
            }
        } catch (ex) {
            showMessage({ status: true, message: t('EXCEPTION_PROCESS') });
        }
        setShowProcessing(false);
    }

    const showMessage = ({ status, title, message, otherMessage, callBackFn }) => {
        setShowProcessing(false);
        setMessage({ show: status, title: title, content: message, otherMessage, callBackFn: callBackFn ? callBackFn : () => setMessage({}) });
    }

    const onViewProfile = async (event) => {
        setTarget({
            personal_information: true,
        })
    }

    const onSeeMoreFormalities = async (event) => {
        setTarget({
            formalities: true,
        })
    }

  
    return (
        <>
        <SettingsView
            showProcessing={showProcessing}
            menuItems={settingsConfig}
            open={props.open}
            onClose={props.onClose}
            onClickMenu={onClickMenu}
            onLogout={onLogout}
            onViewProfile={onViewProfile}
            onSeeMoreFormalities={onSeeMoreFormalities}
            message={props.message}
            headerPosition='relative'
            width='100%'
            profileImage={profileImage}
            showLoadingProfileImage={showLoadingProfileImage}
            unreadNotificationNumber={unreadNotificationNumber}
            showSecurity={showSecurity}
            isMobilePassSupported={isMobilePassSupported}
            communityRelation={communityRelation}
            isCommunityWorkspace={isCommunityWorkspace}
            isAllowAction={allowAction}
            isGuest={isGuest}
        />


        {target && target.personal_information && <PersonalInformationPage
            open={target.personal_information}
            profileImage={profileImage}
            onFileUpload={props.onFileUpload}
            onLoadProfileImage={props.onLoadProfileImage}
            onClose={() => setTarget({})}
        />}

        {target && target.addresses && <AddressController
            open={target.addresses}
            onClose={() => setTarget({})}
        />}
        {target && target.marketing_prefernces && <MarketingPreferencesPage
            open={target.marketing_prefernces}
            onClose={() => setTarget({})}
            setCurrentLanguage={props.setCurrentLanguage}
        />}
        {target && target.formalities && <FormalitiesController
            open={target.formalities}
            onClose={() => setTarget({})}
        />}
         {target && target.faqs && <FAQs
            open={target.faqs}
            onClose={() => setTarget({})}
        />}
        {target && target.talk_to_us && <ContactUs
            open={target.talk_to_us}
            onClose={() => setTarget({})}
        />}
        {target && target.commerce_preferences && <CommercePreferencesPage
            open={target.commerce_preferences}
            onClose={() => setTarget({})}
        />}
        {target && target.security && <SecurityPage
            open={target.security}
            onClose={() => setTarget({})}
        />}
        {target && target.my_cards && <MyCardsPage
            open={target.my_cards}
            onClose={() => setTarget({})}
        />}
        {notificationMessage && <NotificationsPage
            open={notificationMessage}
            notification={notificationMessage}
            onClose={() => {
                setNotificationMessage(null)
                setTarget({ notification: true })
            }}
            onLoadUnreadNotification={onLoadUnreadNotification}
        />}
        {communicationId && <NotificationsPage
            open={communicationId}
            communication_id={communicationId}
            onClose={() => {
                setTarget({})
                setCommunicationId(null)}}
            onLoadUnreadNotification={onLoadUnreadNotification}
        />}
        {target && target.notifications && <NotificationsPage
            open={target.notifications}
            onClose={() => setTarget({})}
            onLoadUnreadNotification={onLoadUnreadNotification}
        />}
        {target && target.my_tickets && <ServiceRequestController
            open={target.my_tickets}
            onClose={() => setTarget({})}
        />}
        {target && target.mobile_pass_card && <MobilePassCardController
            isOpen={target.mobile_pass_card}
            onClose={() => setTarget({})}
        />} 
        {target && target.learn && <LearnController
            isOpen={target.learn}
            onClose={() => setTarget({})}
            onCloseAll={() => {
                cache.setShowSubOptions(true)
                setTarget({})
                props.onClose();
                navigate(0);
            }}
        />} 

        {confirm && confirm.show && <ConfirmComponent
            isOpen={confirm.show}
            message={confirm.message}
            title={confirm.title}
            actionTitle={confirm.actionTitle}
            closeTitle={confirm.closeTitle}
            onClose={confirm.onClose}
            onAction={confirm.onAction}
        />}

        {showMessageLogoutCommunity && <ConfirmComponent
            isOpen={showMessageLogoutCommunity}
            message={t('LOGOUT_COMMUNITY_FAIL')}
            title={t('warning')}
            onClose={() => setShowMessageLogoutCommunity(false)}
            onAction={onLogout}
            />}

        {message && message.show && <AlertComponent
            isOpen={message.show}
            message={message.content}
            otherMessage={message.otherMessage ? message.otherMessage : null}
            onClose={message.callBackFn}
        />}

    </>         
    
    )
}
